import usePaginatedRegisters from '@/modules/PaginatedRegisters.js'
import { ref } from 'vue'

const companies = ref([])
const total_companies = ref(0)
const company_filters = ref({})
const loading = ref(false)

export default function useCompanies() {
  const {
    listRegisters,
    get_api_path,
    save_api_path,
    getAllRegisters,
    search_and_paginate_api_path,
    destroy_api_path,
    destroyRegister,
    saveRegister,
    getRegister,
  } = usePaginatedRegisters()

  //all_registers_api_path.value = "/api/companies/all";
  search_and_paginate_api_path.value = '/api/companies/searchAndPaginate'
  get_api_path.value = '/api/companies/get/'
  save_api_path.value = '/api/companies/storeOrUpdate'
  destroy_api_path.value = '/api/companies/destroy/'

  const listCompanies = async (page, per_page) => {
    loading.value = true

    return new Promise((resolve, reject) => {
      listRegisters(page, per_page, company_filters.value)
        .then((response) => {
          total_companies.value = response.data.meta.total
          companies.value = response.data.data
          resolve()
        })
        .catch((error) => {
          console.log(error)
          reject()
        })
        .finally(() => (loading.value = false))
    })
  }

  const destroyCompany = async (id, index) => {
    destroyRegister(id).then(() => {
      companies.value.splice(index, 1)
    })
  }

  return {
    companies,
    total_companies,
    company_filters,
    loading,
    listCompanies,
    destroyCompany,
    getAllCompanies: getAllRegisters,
    saveCompany: saveRegister,
    getCompany: getRegister,
  }
}
